import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as actionTypes from './constants';

import {
  TimelineSuccess,
  TimelineFailure,
  TimelineFutureSuccess,
  TimelineFutureFailure,
  TimelinePastSuccess,
  TimelinePastFailure,
} from './timeline-actions';

export function* fetchTimeline(action) {
  try {
    const filters = [
      action.payload.filter,
      action.payload.status,
      action.payload.object,
      action.payload.selectedType,
    ];
    const { type, id } = action.payload;
    const results = yield call(callApi, {
      endpoint: `timeline/${type}/${id}?filters=${filters.join()}`,
      options: {
        errorMessage: `Could not get timeline data for ${type}: ${id}`,
        retryAction: action,
      },
    });
    yield put(TimelineSuccess(results));
  } catch (err) {
    yield put(TimelineFailure(err));
  }
}

export function* fetchTimelineFuture(action) {
  try {
    const filters = [
      action.payload.filter,
      action.payload.status,
      action.payload.object,
      action.payload.selectedType,
    ];
    const { type, id, date } = action.payload;
    const results = yield call(callApi, {
      endpoint: `timeline/${type}/${id}/future/?date=${date}&filters=${filters.join()}&sizeHint=5`,
      options: {
        errorMessage: `Could not get future timeline data for ${type}: ${id}`,
        retryAction: action,
      },
    });
    yield put(TimelineFutureSuccess(results));
  } catch (err) {
    yield put(TimelineFutureFailure(err));
  }
}

export function* fetchTimelinePast(action) {
  try {
    const filters = [
      action.payload.filter,
      action.payload.status,
      action.payload.object,
      action.payload.selectedType,
    ];
    const { type, id, date } = action.payload;
    const results = yield call(callApi, {
      endpoint: `timeline/${type}/${id}/past/?date=${date}&filters=${filters.join()}`,
      options: {
        errorMessage: `Could not get past timeline data for ${type}: ${id}`,
        retryAction: action,
      },
    });
    yield put(TimelinePastSuccess(results));
  } catch (err) {
    yield put(TimelinePastFailure(err));
  }
}

function* watchFetchTimeline() {
  yield takeLatest(actionTypes.TIMELINE_REQUEST, fetchTimeline);
}

function* watchFetchTimelineFuture() {
  yield takeLatest(actionTypes.TIMELINE_REQUEST_FUTURE, fetchTimelineFuture);
}

function* watchFetchTimelinePast() {
  yield takeLatest(actionTypes.TIMELINE_REQUEST_PAST, fetchTimelinePast);
}

export default [
  fork(watchFetchTimeline),
  fork(watchFetchTimelineFuture),
  fork(watchFetchTimelinePast),
];
